import { isNative } from '../../services/native/native';
import * as ConfigService from '../../config/ConfigService';
import { ROUTES } from 'ts/Routes';

// we need a hash url for native to retain the url params
// we cannot use the boostrap urls as native needs
// to handle the auth0 sdk call themselves and not
// on the web app. This allows the native app
// to do the correct redirects back into the app
// after login/register

const getNativeRegisterUrl = (): string => `#${ROUTES.REGISTER_ENTER_USERNAME}`;

const getLoginUrl = (): string => `#${ROUTES.LOGIN}`;

const getNativeResetPasswordUrl = (): string => `#${ROUTES.RESET_PASSWORD_ENTER_USERNAME}`;

const getRegisterUrl = () => {
  return isNative() ? getNativeRegisterUrl() : ConfigService.getRegisterBootstrapUrl();
};

const getForgotEmailUrl = (): string => `#${ROUTES.FORGOT_USERNAME_FIND_CUSTOMER}`;

const getForgotPasswordUrl = () => {
  return isNative() ? getNativeResetPasswordUrl() : ConfigService.getResetPasswordBootstrapUrl();
};

export { getForgotPasswordUrl, getRegisterUrl, getLoginUrl, getForgotEmailUrl };
